import type { RootState } from './index';
import type { IOffer } from '../types';

export const selectFilteredOffers = (state: RootState): IOffer[] => {
    const { items, filters } = state.offers;
    const { status_code, buyer_code, vendor_name, search, protection, my } = filters;

    const filtered = items.filter((offer) => {
        if (status_code !== 'all' && String(offer.status_code) !== status_code) return false;
        if (buyer_code !== 'all' && String(offer.buyer_code) !== buyer_code) return false;
        if (vendor_name !== 'all' && offer.vendor_name !== vendor_name) return false;
        if (protection && offer.status_name !== 'Отборка завершена') return false;

        // "Мои" — requires current user login stored in localStorage
        if (my) {
            const currentBuyerCode = localStorage.getItem('user_buyer_code');
            if (currentBuyerCode && String(offer.buyer_code) !== currentBuyerCode) return false;
        }

        if (search) {
            const s = search.toLowerCase();
            const matchesSearch =
                (offer.offer_id || '').toLowerCase().includes(s) ||
                (offer.buyer_name || '').toLowerCase().includes(s) ||
                (offer.vendor_name || '').toLowerCase().includes(s) ||
                (offer.dat || '').includes(s) ||
                (offer.dat_supply || '').includes(s);
            if (!matchesSearch) return false;
        }

        return true;
    });

    // Default sort: date desc, status, vendor
    filtered.sort((a, b) => {
        const dateA = a.dat || '';
        const dateB = b.dat || '';
        if (dateA !== dateB) return dateB.localeCompare(dateA); // desc
        const statusA = a.status_name || '';
        const statusB = b.status_name || '';
        if (statusA !== statusB) return statusA.localeCompare(statusB, 'ru');
        const vendorA = a.vendor_name || '';
        const vendorB = b.vendor_name || '';
        return vendorA.localeCompare(vendorB, 'ru');
    });

    return filtered;
};

export const selectSelectedOffer = (state: RootState): IOffer | undefined => {
    const { items, selectedCode, currentOffer } = state.offers as any;
    const found = items.find((o: IOffer) => Number(o.code) === selectedCode);
    if (found) return found;
    if (currentOffer && Number(currentOffer.code) === selectedCode) return currentOffer;
    return undefined;
};

export const selectUniqueVendors = (state: RootState): string[] => {
    const vendors = new Set(state.offers.items.map(o => o.vendor_name).filter(Boolean) as string[]);
    return Array.from(vendors).sort();
};

export const selectUniqueBuyers = (state: RootState): string[] => {
    const buyers = new Set(state.offers.items.map(o => o.buyer_name).filter(Boolean) as string[]);
    return Array.from(buyers).sort();
};
